import AppRecord from './AppRecord.js'
import APP from 'src/main.js'

class Coract extends AppRecord {
  resetMomerizedComputed(){
    this._issue_name = undefined
  }
  get issue(){
    return this.constructor.employeeStore.issues.find(isx => isx.id === this.issue_id)
  }
  get issue_name(){
    if(this._issue_name){return this._issue_name}
    if(this.issue){
      this._issue_name = this.issue.name
      return this._issue_name
    } else {
      return null
    }
  }
  get new_issue(){
    return this.constructor.employeeStore.issues.find(isx => isx.id === this.new_issue_id)
  }
  // Create special setters and getters mapping to recived values of dates. These
  // allow for taking form input to set the real values communicated to the
  // server.
  get form_anndate(){
    return this.anndate
  }
  set form_anndate(date_string){
    this.setDateFromInput(date_string, 'anndate')
  }
  get form_exdate(){
    return this.exdate
  }
  set form_exdate(date_string){
    this.setDateFromInput(date_string, 'exdate')
  }
  get form_paydate(){
    return this.paydate
  }
  set form_paydate(date_string){
    this.setDateFromInput(date_string, 'paydate')
  }
}
export default Coract
